export function renderProgressBar(): HTMLElement {
  const bar = document.createElement('div');
  bar.className = 'progress-bar';
  bar.setAttribute('aria-hidden', 'true');
  const fill = document.createElement('div');
  fill.className = 'progress-fill';
  bar.appendChild(fill);
  return bar;
}

export function setupProgressBar(bar: HTMLElement): void {
  const fill = bar.querySelector<HTMLElement>('.progress-fill');
  if (!fill) return;

  let pending = false;
  function update(): void {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const pct = max <= 0 ? 0 : (window.scrollY / max) * 100;
      fill!.style.transform = `scaleX(${pct / 100})`;
      pending = false;
    });
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
}
